export default __webpack_public_path__ + "static/media/logoBArmy.15fec58f.png";